import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { IResponse } from '../../app-interface';
import { MagicNumber } from '../../app-magic-string';
import { AgentManagementService } from '../../services/agent-management.service';
import { QrcodeManagementService } from '../../services/qrcode-management.service';

@Component({
  selector: 'app-manage-qrcode',
  templateUrl: './manage-qrcode.component.html',
  styleUrls: ['./manage-qrcode.component.scss']
})
export class ManageQrcodeComponent implements OnInit {

  public data;
  public manageEvent = new EventEmitter();
  public manageQrCodeForm: FormGroup;
  public QRCodes = [MagicNumber.ten, MagicNumber.fifty, MagicNumber.hundred, MagicNumber.twoHundred, MagicNumber.fiveHundred];
  public selectedIndex: number = MagicNumber.zero;
  @Output() onClose = new EventEmitter();
  agentDetails;
  dropdownOpen = false;
  selectedOption: any;
  selectedOptionId: any;
  rememberAssign = false;
  remAssign = false;

  constructor(public formBuilder: FormBuilder, public modalRef: BsModalRef , public modalService: BsModalService, 
    public qrcodeService : QrcodeManagementService, public toaster: ToastrService,  public agentService: AgentManagementService) {
    this.manageQrCodeForm = this.formBuilder.group({
      selectedOption: [''],
      rememberAssign: ['']
    });
  }


  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectOption(option: string) {
    this.selectedOption = option['name'];
    this.selectedOptionId = option['id'];
    this.dropdownOpen = false;
  }

  ngOnInit(): void {
    this.getAgent();
  }

  getAgent() {
    this.qrcodeService.getAgentList().subscribe((res) => {
      this.agentDetails = res['data'];
    });
  }





  /**
   * form param return
  */

  get qrCodeType() { return this.manageQrCodeForm.get('qrCodeType'); }

  get qrCodeNumber() { return this.manageQrCodeForm.get('qrCodeNumber'); }



  /**
   * On generate QR code form submit
  */
  manageQrCode() {
    if (this.manageQrCodeForm.valid) {
      const data = {
        close: true,
        manageQrCodeForm: this.manageQrCodeForm.value
      };
      this.onClose.next(data);
      this.onClosed();
    } else {
      this.manageQrCodeForm.markAllAsTouched();
    }
  }

    assignQrCode() {
      if(this.manageQrCodeForm.value['rememberAssign']===1){
        this.remAssign = true;
      } 
      if(this.manageQrCodeForm.value['rememberAssign']===0 && !this.selectedOption){
        this.toaster.error('Please select agent');
        return;
      }
      this.agentService.assignQrCod(this.data,this.selectedOption,this.remAssign).subscribe((res: IResponse) => {
        if (res && !res.errors) {
          this.toaster.success(res.message);
          this.manageEvent.emit({ res: 200 });
          this.modalRef.hide();
        }
      });
  }

  updateCheckedOptions(event) {
    this.rememberAssign = event.target.checked;
    if(this.rememberAssign === true){
    this.manageQrCodeForm.get('rememberAssign').setValue(1);
    } else{
    this.manageQrCodeForm.get('rememberAssign').setValue(0);
    }
  }

  onClosed() {
    this.modalService.hide();
  }


  /**
   * Activate Selected QR Code
   * @param index is an selected index
   * @param value is selected Item
  */
  setIndex(index: number, value: number) {
    this.selectedIndex = index;
    this.manageQrCodeForm.controls.qrCodeNumber.setValue(value);
  }



//   unassignQrCode() {
//     this.agentService.unassignQrCod(this.data).subscribe((res: IResponse) => {
//       if (res && !res.errors) {
//         this.toaster.success(res.message);
//         this.unassignEvent.emit({ res: 200 });
//         this.modalRef.hide();
//       }
//     });
// }


  /**
   * Change event type
   * @param event is an action
  */



}

